import { useState } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';
import { TAPIResponse } from '../../api.types';

export type TAPIState = {
  key: string;
  state: string;
};

export enum TStatesCode {
  US = 'US',
  CA = 'CA',
  IN = 'IN',
}

export type TAPIHookFetchStatesResponse = TAPIResponse & {
  fetchStates(code: TStatesCode): Promise<TAPIState[]>;
};

export const useAPIFetchStates = (): TAPIHookFetchStatesResponse => {
  const [responseData, setResponseData] = useState<TAPIState[]>([]);
  const { get, response, loading, error } = useFetch(API_ROUTES.COMMON, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  async function fetchStates(code: TStatesCode): Promise<TAPIState[]> {
    const { data } = await get(`${code}/states`);

    if (response.ok) {
      setResponseData(data.items);
    }

    return Promise.resolve(data?.items || []);
  }

  return {
    loading,
    error,
    data: responseData,
    loaded: Boolean(response.ok),
    fetchStates,
  };
};
